/** flash.display.FrameLabel. */
export class FrameLabel {
  /** @internal */ $name: string;
  /** @internal */ $frame: number;
  constructor(name: string = '', frame: number = 0) {
    this.$name = name;
    this.$frame = frame;
  }
  get name(): string {
    return this.$name;
  }
  get frame(): number {
    return this.$frame;
  }
}
